<mat-sidenav-container class="layout" autosize>
  @if (!isAuthPage()) {
    <mat-sidenav
      #sidenav
      class="layout__drawer"
      [class.layout__drawer--collapsed]="isCollapsed()"
      [mode]="isMobile() ? 'over' : 'side'"
      [opened]="!isMobile()"
      [fixedInViewport]="isMobile()"
    >
      <header class="drawer__header">
        <a class="drawer__brand" routerLink="/home" (click)="closeDrawerIfMobile()">
          <mat-icon class="drawer__brand-icon">sports_martial_arts</mat-icon>
          <span class="drawer__brand-text">Jitsupedia</span>
        </a>
        @if (!isMobile()) {
          <button
            matIconButton
            class="drawer__collapse-btn"
            (click)="toggleCollapse()"
            [matTooltip]="isCollapsed() ? 'Espandi menu' : 'Comprimi menu'"
            aria-label="Toggle menu"
          >
            <mat-icon>{{ isCollapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
          </button>
          <button
            matIconButton
            class="drawer__expand-btn"
            (click)="toggleCollapse()"
            matTooltip="Espandi menu"
            aria-label="Espandi menu"
          >
            <mat-icon>chevron_right</mat-icon>
          </button>
        } @else {
          <button matIconButton (click)="sidenav.close()" aria-label="Chiudi menu">
            <mat-icon>close</mat-icon>
          </button>
        }
      </header>

      <nav class="drawer__nav">
        <mat-nav-list>
          <a
            mat-list-item
            routerLink="/home"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeDrawerIfMobile()"
          >
            <mat-icon matListItemIcon>home</mat-icon>
            <span matListItemTitle class="drawer__nav-text">Home</span>
          </a>
        </mat-nav-list>

        <div class="drawer__section-label">
          <span class="drawer__section-label-text">Settori</span>
        </div>

        <mat-nav-list>
          @for (sector of sectors; track sector) {
            <a
              mat-list-item
              [routerLink]="['/sector', sector]"
              routerLinkActive="active"
              (click)="closeDrawerIfMobile()"
            >
              <mat-icon matListItemIcon>{{ sectorIcons[sector] }}</mat-icon>
              <span matListItemTitle class="drawer__nav-text">Settore {{ sector }}</span>
            </a>
          }
        </mat-nav-list>

        <div class="drawer__section-label">
          <span class="drawer__section-label-text">App</span>
        </div>

        <mat-nav-list>
          <a
            mat-list-item
            routerLink="/settings"
            routerLinkActive="active"
            (click)="closeDrawerIfMobile()"
          >
            <mat-icon matListItemIcon>settings</mat-icon>
            <span matListItemTitle class="drawer__nav-text">Impostazioni</span>
          </a>
        </mat-nav-list>
      </nav>

      <footer class="drawer__footer">
        @if (isAuthenticated()) {
          <a
            class="drawer__user"
            routerLink="/profile"
            (click)="closeDrawerIfMobile()"
            matTooltip="Profilo"
          >
            <div class="drawer__avatar">
              @if (hasAvatar()) {
                <img [src]="userAvatarUrl()" alt="" class="drawer__avatar-img" />
              } @else if (userInitials(); as initials) {
                <span class="drawer__avatar-initials">{{ initials }}</span>
              } @else {
                <mat-icon>person</mat-icon>
              }
            </div>
            <div class="drawer__user-info">
              <span class="drawer__user-name">{{ currentUser()?.name ?? 'Utente' }}</span>
              <span class="drawer__user-action">Profilo</span>
            </div>
          </a>
          <div class="drawer__footer-actions">
            <button
              matIconButton
              (click)="toggleTheme()"
              [matTooltip]="isDark() ? 'Modalità chiara' : 'Modalità scura'"
              [attr.aria-label]="
                isDark() ? 'Passa alla modalità chiara' : 'Passa alla modalità scura'
              "
            >
              <mat-icon>{{ isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
            </button>
            <button matIconButton (click)="logout()" matTooltip="Logout" aria-label="Logout">
              <mat-icon>logout</mat-icon>
            </button>
          </div>
        } @else {
          <div class="drawer__footer-actions">
            <a
              mat-button
              routerLink="/login"
              (click)="closeDrawerIfMobile()"
              class="drawer__login-btn"
            >
              <mat-icon>login</mat-icon>
              <span>Accedi</span>
            </a>
            <button
              matIconButton
              (click)="toggleTheme()"
              [matTooltip]="isDark() ? 'Modalità chiara' : 'Modalità scura'"
              [attr.aria-label]="
                isDark() ? 'Passa alla modalità chiara' : 'Passa alla modalità scura'
              "
            >
              <mat-icon>{{ isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
            </button>
          </div>
        }
      </footer>
    </mat-sidenav>
  }

  <mat-sidenav-content class="layout__content" [class.layout__content--no-nav]="isAuthPage()">
    @if (!isAuthPage()) {
      <header class="layout__mobile-header">
        <button matIconButton class="layout__menu-btn" (click)="toggleMenu()" aria-label="Menu">
          <mat-icon>menu</mat-icon>
        </button>
        <span class="layout__mobile-title">Jitsupedia</span>
      </header>
    }

    <main class="layout__main">
      <router-outlet />
    </main>

    @if (!isAuthPage()) {
      <app-bottom-nav />
    }
  </mat-sidenav-content>
</mat-sidenav-container>
